var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('h4',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.section.label))]),_vm._l((_vm.section.fields),function(fieldSection,index){return _c('device-settings-body-section-field',{key:index,attrs:{"field":fieldSection,"sectionValue":_vm.value,"section":_vm.section},on:{"changeValue":_vm.changeValue}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }